module.exports = __webpack_public_path__ + "static/media/ic_delete.d36bd4a7.svg";